var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 60,
    viewBox: "0 0 86 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.3388 9.38797C82.3628 5.69266 79.4871 2.78234 75.8359 1.79469C69.2178 0 42.6801 0 42.6801 0C42.6801 0 16.1425 0 9.52424 1.79469C5.87303 2.7825 2.99737 5.69266 2.02136 9.38797C0.248047 16.0859 0.248047 30.0606 0.248047 30.0606C0.248047 30.0606 0.248047 44.0353 2.02136 50.7333C2.99737 54.4286 5.87303 57.2177 9.52424 58.2053C16.1425 60 42.6801 60 42.6801 60C42.6801 60 69.2177 60 75.8359 58.2053C79.4871 57.2177 82.3628 54.4286 83.3388 50.7333C85.1121 44.0353 85.1121 30.0606 85.1121 30.0606C85.1121 30.0606 85.1121 16.0859 83.3388 9.38797ZM34.0007 42.7486V17.3727L56.181 30.0609L34.0007 42.7486Z",
    fill: "#233B92"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube_icon.b6b73bc65622565a86cedeeed8126608.svg";
export { ForwardRef as ReactComponent };